import { inlineAtomNode } from '#src/tiptap/nodes/shared.ts'

export const ChoiceNode = inlineAtomNode('choice', 'button', {
  options: { dataAttr: 'data-options', default: '' },
  dropdown: { dataAttr: 'data-dropdown' },
  /* Opaque, durable handle the AI uses to target this choice field across
   * turns. Created at template save (see createChoiceFieldIds). Optional, so
   * existing notes and templates without it parse fine. */
  fieldId: { dataAttr: 'data-field-id' },
  display: { isDisplay: true },
})
